import React from 'react';

// Components
import { DataBlocks } from 'components';
import { ActiveOffer } from './components/ActiveOffer';
import { UsingOffer } from './components/UsingOffer';
import { Header } from './components/Header';
import { useFetchEcoRoumingData } from './hooks';

const EcoRoaming = () => {
  const data = useFetchEcoRoumingData();

  if (!data) {
    return null;
  }

  const {
    isRoaming,
    title,
    roamingTitle,
    titleImageUrl,
    roamingTitleImageUrl,
    info,
    activeOffer,
    usingOfferInfo,
    roamingParams,
    accumulator,
    packageInfo,
  } = data;

  const getOffer = activeOffer
    ? <ActiveOffer activeOffer={activeOffer} />
    : <UsingOffer {...{ usingOfferInfo, roamingParams, accumulator, packageInfo }} />;

  return (
    <>
      <DataBlocks.Block>
        <Header {...{
          isRoaming,
          title,
          roamingTitle,
          titleImageUrl,
          roamingTitleImageUrl,
          info,
        }}
        />
        <div>
          {getOffer}
        </div>
      </DataBlocks.Block>
    </>
  );
};

export default EcoRoaming;
